import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../components/layouts/WithLoader";
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};
function convertProductData(data) {
  return data.map((item) => ({
    id: item.productSellingPrice.product.id,
    name: item.productSellingPrice.product.name,
    productCode: item.productSellingPrice.product.productCode,
    barcode: item.productSellingPrice.product.barcode || "N/A",
    sellingPrice: `${item.productSellingPrice.initialSellingPrice} ${item.productSellingPrice.devise}` || 0,
    tva: item.productSellingPrice.product.tva || 0,
    minimumQuantity: item.quantity || 0,
    onSale: item.productSellingPrice.product.onSale || false,
  }));
}

const TicketDetails = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [products, setProducts] = useState([]);
  const [payement, setPayement] = useState({});

  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    onGetTickets();
  }, []);

  const onGetTickets = () => {
    startLoading();
    WarehouseService.getOrderByRef(getCurrentUserId(), localStorage.getItem("reference"))
      .then((response) => {
        if (response?.data?.Success) {
          setData(response.data.Success);
          setPayement(response.data.payement)
          console.log("------------------------------------------------->", response?.data?.Success?.products)
          const productData = convertProductData(response?.data?.Success?.products || []);
          setProducts(productData);
        }
      })
      .catch((error) => {
        setAlertMessage("Error: " + error.message);
      })
      .finally(() => {
        stopLoading();
      });
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {/* Header Section */}
      <section className="content-header">
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="" style={{ display: "flex", padding: "20px", justifyContent: "space-between" }}>
              <h5 className="card-title">Les Tickets de caisse</h5>


              <p>
                <small>
                  Référence: <b>{localStorage.getItem("reference")}</b>
                </small>
              </p>

            </div>
          </div>
        </div>
      </section>

      {/* Ticket Info Section */}
      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Info</h6>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      title="Collapse"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body p-0">
                  <table
                    className="table table-striped table-bordered table-sm"
                    cellSpacing="0"
                    width="100%"
                  >
                    <thead>
                      <tr className="text-center">
                        <th>Référence</th>
                        <th>Caissier</th>
                        <th>Caisse</th>
                        <th>Prix</th>
                        <th>Etat</th>
                        <th>Date de Création</th>
                        <th>Reste à payer</th>

                      </tr>
                    </thead>
                    <tbody>
                      {data && Object.keys(data).length > 0 ? (
                        <>
                          <tr key={data.id} className="text-center">
                            <td>{data.reference}</td>
                            <td>{` ${data.seller.lastName} ${data.seller.firstName}`}</td>
                            <th>{data?.cashRegister?.reference ?? "Site web"}</th>
                            <td>{data.price}</td>
                            <td>{data?.isPayed === 1 ? ('payée') : ('EnCours')}</td>
                            <td>{formatDate(data.creationDate)}</td>
                            <td>{payement.restToPay}</td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Aucune donnée disponible
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Info Section */}
      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Les produits</h6>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      title="Collapse"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body p-0">
                  <table
                    className="table table-striped table-bordered table-sm"
                    cellSpacing="0"
                    width="100%"
                  >
                    <thead>
                      <tr className="text-center">
                        <th>Code du Produit</th>
                        <th>Code à Barres</th>
                        <th>Libellé</th>
                        <th>Prix Unitaire</th>
                        <th>Quantité </th>
                      </tr>
                    </thead>
                    <tbody>
                      {products.length > 0 ? (
                        products.map((element) => (
                          <tr key={element.id} className="text-center">
                            <td>{element.productCode}</td>
                            <td>{element.barcode}</td>
                            <td>{element.name}</td>
                            <td>{element.sellingPrice}</td>
                            <td>{element.minimumQuantity}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            Aucune donnée disponible
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(TicketDetails);
